import Images from 'constants/images';

const article8Areas = () => {
  const areas = [
    {
      area: 'ict_risk',
      title: 'ICT Risk',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/ict_risk',
    },
    {
      area: 'entity_role',
      title: 'Entity role',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/entity_role',
    },
    {
      area: 'role_type',
      title: 'Role type',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/role_type',
    },
    {
      area: 'ict_risk_source',
      title: 'ICT Risk Source',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/risk_source',
    },
    {
      area: 'ict_risk_level',
      title: 'ICT Risk Level',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/risk_level',
    },
    {
      area: 'risk_exposure',
      title: 'Risk Exposure',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/risk_exposure',
    },
    {
      area: 'exposure_category',
      title: 'Exposure Category',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/exposure_category',
    },
    {
      area: 'dependency_type',
      title: 'Dependency type',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/dependency_type',
    },
    {
      area: 'ict_system_criticality',
      title: 'ICT System criticality',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/ict_system_criticality',
    },
    {
      area: 'responsibilities',
      title: 'Responsibilities',
      imgSrc: Images.dataEntryAreas,
      href: '/article8/responsibility',
    },
  ];
  return areas;
};

export default article8Areas;
